// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"079c8af7","703":"13c371d6","787":"56484539"}[chunkId] + ".chunk.js";
};